















import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class NoticeBox extends Vue {
  @Prop({ required: true })
  private readonly noticeTexts: string[];
  
  @Prop({ default: null })
  private readonly convertTextToI18n: (word: string) => string;
  
  @Prop({ default: false })
  private readonly useI18n: boolean;
  
  @Prop({ default: true })
  private readonly useExclamationMark: boolean;
  
  @Prop({ default: false })
  private readonly convertHtml: boolean;
  
  private noticeText(text: string): string {
    if (this.convertTextToI18n) {
      return this.convertTextToI18n(text);
    }
    
    if (!this.useI18n) {
      return text;
    }
    
    return this.$t(text).toString();
  }
}
